// Full-document render of the anonymous order-STATUS page
// (/store/accounts/order-status/<number>/<hash>/): PageSkeleton wrapping the
// "Your Orders" heading, the shared RichOrderDetail block (the collapsible
// order-summary-details panel + grouped lines with named-status progress bars,
// typed-serialized server-side), and the two empty states. This anonymous page
// carries the shared AnonOrderProps status serialization, NOT the authenticated
// order-detail page's account_rich_order_json tracker seam, so it renders the
// shared block like toppers/one800pillows. The shared block's order-details
// toggle is markup-only (its `--order-details` button carries no onClick and
// never matched tempurpedic's `--order-details-btn` toggle), so the panel keeps
// its default CSS state. The track_order_lookup dataLayer events push after
// hydration so the body stays script-free for full-document hydration.
import React from "react";
import { RichOrderDetail } from "tsi-common-react/src/apps/customer-account/RichOrderDetail/index";
import { DataLayerPush } from "tsi-common-react/src/components/DataLayerPush/index";
import { t } from "ttag";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.AnonOrderDocumentTemplate,
): React.JSX.Element => {
    const { order } = props;
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <section
                id="order-detail"
                className="l-capped-width u-margin-bottom--xl u-full-width-title order-list"
            >
                <h2>{t`Your Orders`}</h2>

                {/* The empty-order-status modifier is ALWAYS on: the legacy
                    template gated it on `{% if not orders %}`, but the view
                    never defines `orders`, so the class rendered on every
                    request -- including with-order renders -- and the mobile
                    orders-page margins key on it. */}
                <div className="content__copy--full-width content__orders-page content__orders-page--empty-order-status">
                    <div className="orders">
                        <ul className="orders__list">
                            {order.has_order ? (
                                <li className="orders__list-item">
                                    <div className="content__copy--full-width order-summary-wrapper">
                                        <RichOrderDetail
                                            summary={order.summary}
                                            shipped_events={
                                                order.shipped_events
                                            }
                                            unshipped={order.unshipped}
                                        />
                                    </div>
                                </li>
                            ) : order.form_is_bound ? (
                                <li className="orders__list-item">
                                    {t`No orders match your search.`}
                                </li>
                            ) : (
                                <li className="orders__list-item orders__list-item--empty-order-status">
                                    <h2 className="orders__list-item__title orders__list-item__title--empty-order-status">
                                        {t`You haven't shopped with us.`}
                                    </h2>
                                    <p className="orders__list-item__copy orders__list-item__copy--empty-order-status">
                                        {t`Please check back after your first purchase to view your order details.`}
                                    </p>
                                    <a className="button" href="/">
                                        {t`Shop now`}
                                    </a>
                                </li>
                            )}
                        </ul>
                    </div>
                </div>
            </section>
            <DataLayerPush events={props.ga_events} />
        </PageSkeleton>
    );
};
